import React from 'react';
import { criarAgentesRecebedoresDs, criarContribuinteDs, criarDistritoDs, criarLogradouroDs, criarBairroDs, criarAliquotaIPTUDs } from '../DataSources';
import notify from "devextreme/ui/notify";
import Form, {
    SimpleItem,
    GroupItem,
    Label
} from 'devextreme-react/form';
import UserInfo from "../UserInfo";
import List from 'devextreme-react/list';
import { ButtonItem } from "devextreme-react/tree-list";

const _novoImovelInativoTemplate = {
    "codInicial": undefined,
    "codFinal": undefined,
    "distritoInicial": undefined,
    "distritoFinal": undefined,
    "setorInicial": undefined,
    "setorFinal": undefined,
    "quadraInicial": undefined,
    "quadraFinal": undefined,
    "loteInicial": undefined,
    "loteFinal": undefined,
    "unidadeInicial": undefined,
    "unidadeFinal": undefined,
    "contribuinteId": undefined,
    "selectedDistritoKeys": [],
    "selectedLogradouroKeys": [],
    "selectedBairroKeys": [],
    "selectedStatusKeys": [],
    "selectedZonaKeys": [],
    "selectedNaturezaKeys": [],
    "selectedAliquotaKeys": [],
    "selectedPosicaoFiscalKeys": [],
    "selectedSituacaoJudicialKeys": [],
    "selectionMode": 'all',
    "selectAllMode": 'page',
};


export default class RelatoriosFiltros extends React.Component {
    constructor(props) {
        super(props);
        console.log(this);
        //this.arrecadacaoDs = criarArrecadacaoDs();
        //console.log(this.arrecadacaoDs);
        //console.log(this.arrecadacaoDs.byKey);
        this.distritosDs = criarDistritoDs();
        this.ok = this.ok.bind(this);
        this.cancel = this.cancel.bind(this);
        this.onSelectionModeChange = this.onSelectionModeChange.bind(this);
        this.onSelectAllModeChange = this.onSelectAllModeChange.bind(this);
        this.onSelectedItemKeysChange = this.onSelectedItemKeysChange.bind(this);
        //this.saidaProgramada = false;
        _novoImovelInativoTemplate.prefeituraId = UserInfo.getPrefeitura();
        this.state = this.props.match.params.id == undefined
            ? _novoImovelInativoTemplate
            : {};

        this.agenteRecebedorOptions = {
            editorType: "dxSelectBox",
            searchEnabled: true,
            placeholder: "Escolher...",
            dataSource: criarAgentesRecebedoresDs(),
            valueExpr: "id",
            displayExpr: "descricao"
        }

        let modelos = [
            { id: 1, descricao: "Modelo 1" },
            { id: 2, descricao: "Modelo 2" },
            { id: 3, descricao: "Modelo 3" },
        ]

        this.escolherModelo = {
            editorType: "dxSelectBox",
            searchEnabled: true,
            placeholder: "Escolher...",
            dataSource: modelos,
            valueExpr: "id",
            displayExpr: "descricao"
        }
    }


    // componentDidMount() {
    //     if (this.props.match.params.id !== undefined) {
    //         this.arrecadacaoDs.byKey(this.props.match.params.id)
    //             .then(data => {
    //                 if (data == undefined) {
    //                     notify("Arrecadação não encontrada.", "error");
    //                     this.props.history.push("/home");
    //                 }
    //                 this.setState(data);
    //             })
    //             .catch(erro => {
    //                 notify(erro, "error");
    //                 this.props.history.goBack();
    //             });

    //     }
    // }

    render() {
        return (
            <div className={'content-block dx-card responsive-paddings'}>
                <List
                    dataSource={this.distritosDs}
                    displayExpr={'descricao'}
                    height={400}
                    showSelectionControls={true}
                    selectionMode={this.state.selectionMode}
                    selectAllMode={this.state.selectAllMode}
                    selectedItemKeys={this.state.selectedDistritoKeys}
                    onOptionChanged={this.onSelectedItemKeysChange}
                >
                </List>
                <Form formData={this.state} colCount={2}>
                    <GroupItem colSpan={2} colCount={2}>
                        <SimpleItem
                            dataField={'dataPagamento'}
                            editorType={'dxCheckBox'}>
                            <Label text="Data de Pagamento" />
                        </SimpleItem>
                        <SimpleItem
                            dataField={'dataDeposito'}
                            editorType={'dxCheckBox'}>
                            <Label text="Data de Depósito" />
                        </SimpleItem>
                        <SimpleItem
                            dataField={'dataInicial'}
                            editorType={'dxDateBox'}
                            editorOptions={{ width: '100%' }}>
                        </SimpleItem>
                        <SimpleItem
                            dataField={'dataFinal'}
                            editorType={'dxDateBox'}
                            editorOptions={{ width: '100%' }}>
                        </SimpleItem>
                        <SimpleItem
                            dataField={'agenteRecebedor'}
                            editorType={'dxLookup'}
                            editorOptions={this.agenteRecebedorOptions}
                            colSpan={2}>
                            <Label text="Agente Recebedor" />
                        </SimpleItem>
                        <SimpleItem
                            dataField={'modelo'}
                            editorType={'dxLookup'}
                            editorOptions={this.escolherModelo}
                            colSpan={2}>
                            <Label text="Modelo" />
                        </SimpleItem>
                    </GroupItem>
                </Form>
                <br></br>
                <Form>
                    <GroupItem colCount={6}>
                        <ButtonItem horizontalAlignment={'center'} buttonOptions={{ type: "success", text: "Salvar", onClick: this.ok }} />
                        <ButtonItem horizontalAlignment={'center'} buttonOptions={{ type: "warn", text: "Cancelar", onClick: this.cancel }} />
                    </GroupItem>
                </Form>
            </div>
        );
    }

    onSelectionModeChange(args) {
        this.setState({
            selectionMode: args.value
        });
    }
    onSelectAllModeChange(args) {
        this.setState({
            selectAllMode: args.value
        });
    }

    onSelectedItemKeysChange(args) {
        console.log(this.state.selectedDistritoKeys)
        if (args.name === 'selectedDistritoKeys') {
            this.setState({
                selectedDistritoKeys: args.value
            });
        }
    }

    ok() {
        notify("OK");

    }

    cancel() {
        notify("Cancelado", "warning");
        this.props.history.goBack();
    }
}
